import React, { ComponentProps, ReactNode } from 'react';
import Layout from 'components/Layout';
import { ThemeProvider } from 'styled-components';
import { Theme } from 'lib/theme';

type ErrorPageProps = ComponentProps<typeof Layout> & {
  theme?: Theme;
  children: ReactNode;
};

const ErrorPage = ({
  theme = 'duoDark',
  children,
  centered,
  headless = false,
  ...props
}: ErrorPageProps) => (
  <ThemeProvider theme={{ mode: theme }}>
    <Layout headless={headless} centered={centered} {...props}>
      {children}
    </Layout>
  </ThemeProvider>
);

export default ErrorPage;
